import { injectIntl } from 'react-intl';
import { useMsal } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';
import Button from 'src/componentes/button';
import { Row, Col } from 'src/componentes/grid';

const ConectarIntegracaoMicrosoft = ({ intl }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const handleConnect = (isUserAuthenticated) => {
    if (!isUserAuthenticated) {
      instance
        .loginPopup({
          scopes: [],
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      instance.logoutPopup();
    }
  };

  return (
    <>
      <Row className=" align-items-center p-3 justify-content-between">
        <Col md={6}>
          <span className="text-muted">
            {intl.formatMessage({
              id: 'infoAnexoSistemaConectarMicrosoftSharepoint',
            })}
          </span>
        </Col>

        <Col md={5}>
          <Button
            id={'conectarComMicrosoft'}
            key={'conectarComMicrosoft'}
            onClick={() => handleConnect(isAuthenticated)}
            outline
          >
            <img alt="Microsoft logo" src="/integracoes/microsoft-black.svg" />
            <div className="ml-2 font-weight-bold">
              <span id="desconectar">
                {intl.formatMessage({ id: 'conectarComMicrosoft' })}
              </span>
            </div>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default injectIntl(ConectarIntegracaoMicrosoft);
